import React, { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { motion } from 'framer-motion';
import Button from '../components/Common/Button';
import { submitDemoTalep } from '../utils/api';
import './Contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    company: '',
    message: ''
  });

  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    try {
      // API'ye form verilerini gönder
      await submitDemoTalep(formData);
      
      // Başarılı mesajı göster
      setSubmitted(true);
      
      // Formu temizle
      setFormData({
        name: '',
        email: '',
        phone: '',
        company: '',
        message: ''
      });
      
      // 3 saniye sonra başarı mesajını gizle
      setTimeout(() => {
        setSubmitted(false);
      }, 3000);
      
    } catch (error) {
      // Hata durumunda kullanıcıya bilgi ver
      alert('Form gönderilirken bir hata oluştu: ' + error.message);
      console.error('Form submission error:', error);
    }
  };

  return (
    <>
      <Helmet>
        <title>İletişim - FlowSky CRM</title>
        <meta 
          name="description" 
          content="FlowSky CRM ile iletişime geçin. Sorularınız için bize ulaşın veya demo talep edin." 
        />
      </Helmet>
      
      <section className="contact-page section">
        <div className="container">
          <motion.div
            className="section-header"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <h1 className="section-title">İletişime Geçin</h1>
            <p className="section-subtitle">
              Sorularınız için bize ulaşın veya demo talep edin
            </p>
          </motion.div>

          <div className="contact-content">
            <motion.form
              className="contact-form"
              onSubmit={handleSubmit}
              initial={{ opacity: 0, x: 30 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6 }}
            >
              <div className="form-group">
                <label htmlFor="name">Ad Soyad *</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="email">E-posta *</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="phone">Telefon</label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                />
              </div>

              <div className="form-group">
                <label htmlFor="company">Şirket Adı</label>
                <input
                  type="text"
                  id="company"
                  name="company"
                  value={formData.company}
                  onChange={handleChange}
                />
              </div>

              <div className="form-group">
                <label htmlFor="message">Mesaj *</label>
                <textarea
                  id="message"
                  name="message"
                  rows="5"
                  value={formData.message}
                  onChange={handleChange}
                  required
                ></textarea>
              </div>

              {submitted && (
                <div className="form-success">
                  Mesajınız başarıyla gönderildi!
                </div>
              )}

              <Button type="submit" variant="primary" size="medium" className="submit-button">
                Gönder
              </Button>
            </motion.form>
          </div>
        </div>
      </section>
    </>
  );
};

export default Contact;

